import { useContext } from "react";

import { TasksContextMenuContext } from "./TasksContextMenuContext";

export function useTasksContextMenu() {
  const context = useContext(TasksContextMenuContext);
  if (!context) {
    throw new Error("useTasksContextMenu must be used within a TasksContextMenuProvider");
  }
  return context;
}
